import React from 'react'
import TimeSet from '../Components/TimeSet/TimeSet'

const TimeSetView = () => {
  return (
    <div>
        <TimeSet />
    </div>
  )
}

export default TimeSetView